import { convertArrayToObject } from "Services/Entity/helper";
import { getActionType } from "Store/Shared/Actions/Helpers"
import ACTIONS from "./ActionTypes"

const initialState = {
    _isFetching: false,
    _forceFetch: true,
    ids: [],
    entities: {},
    byExtension: {}
}
const settingsExtensionsReducer = (state = initialState, { payload, type }: any) => {
    switch (type) {
        case getActionType(ACTIONS.FETCH_EXTENSIONS).REQUEST: {
            return {
                ...state,
                _forceFetch: false,
                _isFetching: true
            }
        }

        case getActionType(ACTIONS.FETCH_EXTENSIONS).SUCCESS: {
            const { data } = payload;
            const ids: any = data.map(({id}) => (id));
            const entities: any = convertArrayToObject(data, 'id');
            const byExtension: any = {};
            data.forEach((i: any) => byExtension[i.extension] = i.id);

            return {
                ...state,
                _isFetching: false,
                _forceFetch: false,
                ids,
                entities,
                byExtension
            }
        }

        case getActionType(ACTIONS.CREATE_EXTENSION).REQUEST:
        case getActionType(ACTIONS.PATCH_EXTENSION).REQUEST: {
            return {
                ...state,
                _forceFetch: true
            }
        }

        case getActionType(ACTIONS.PATCH_EXTENSION).SUCCESS:
        case getActionType(ACTIONS.CREATE_EXTENSION).SUCCESS: {
            const { data } = payload;
            const ids = [...state.ids, data.id];
            const entities = {
                ...state.entities,
                [data.id]: data
            };
            const byExtension = {
                ...state.byExtension,
                [data.extension]: data.id
            }

            return {
                ...state,
                _isFetching: false,
                _forceFetch: false,
                ids,
                entities,
                byExtension
            }
        }

        default:
            return state;
    }
}

export default settingsExtensionsReducer;